import { render, staticRenderFns } from "./MapTiler.vue?vue&type=template&id=632b2007&"
import script from "./MapTiler.vue?vue&type=script&lang=js&"
export * from "./MapTiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports